import React from 'react';
import './Footer.css';
import facebookIcon from '../assets/svg/fa-facebook.svg';
import instagramIcon from '../assets/svg/fa-instagram.svg';
import tiktokIcon from '../assets/svg/fa-tiktok.svg';
import youtubeIcon from '../assets/svg/fa-youtube.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">

        <div className="footer-columns">
          {/* LEFT COLUMN */}
          <div className="footer-column">
            <img src={require('./assets/beszELJ_logo2.png')} alt="Logo" className="footer-logo" />

            <a href="/about" className="footer-left-link">Rólunk</a>
            <a href="/events" className="footer-left-link">Események</a>
            <a href="/stuttering" className="footer-left-link">Dadogás</a>
            <a href="/faq" className="footer-left-link">Kérdések</a>
            <a href="/contact" className="footer-left-link">Kapcsolat</a>
          </div>

          {/* MIDDLE COLUMN */}
          <div className="footer-column">
            <p className="footer-title">Tudástár</p>
            <a className="footer-link" href="#">Mi a dadogás?</a>
            <a className="footer-link" href="#">Gyakori tévhitek és igazságok</a>
            <a className="footer-link" href="#">Tippek a kommunikációhoz</a>
            <a className="footer-link" href="#">Tanácsok szülőknek és tanároknak</a>
            <a className="footer-link" href="#">Hasznos kutatási források</a>
          </div>

          {/* RIGHT COLUMN */}
          <div className="footer-column">
            <p className="footer-title">Támogass minket</p>
            <a className="footer-link" href="#">Tagság</a>
            <a className="footer-link" href="#">Adományozz</a>
            <a className="footer-link" href="#">Legyél önkéntes</a>
            <a className="footer-link" href="#">Partnerként támogass</a>
          </div>
        </div>

        {/* BOTTOM ROW */}
        <div className="footer-bottom">
          <p>Copyright © 2025 BeszÉLJ</p>

          <div className="footer-bottom-right">
            <p className="footer-placeholder">Placeholder</p>
            <div className="footer-socials">
              <a href="#"><img src={facebookIcon} alt="Facebook" /></a>
              <a href="#"><img src={instagramIcon} alt="Instagram" /></a>
              <a href="#"><img src={tiktokIcon} alt="TikTok" /></a>
              <a href="#"><img src={youtubeIcon} alt="YouTube" /></a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
